import { BaseController } from '@shared/basecontroller.controller';
import { RequestProductPasswordForm } from './model/form.model';
import { hideModal } from '../../ui/modal.util';
import ProductPasswordFormErrorModel from './model/form-error.model';

export class ProductPassword {
  constructor(FormService, SessionService, CustomerApiService, TransactionApiService, AppService, $state, $timeout, $scope) {
    'ngInject';

    this.SessionService = SessionService;
    this.FormService = FormService;
    this.CustomerApiService = CustomerApiService;
    this.TransactionApiService = TransactionApiService;
    this.AppService = AppService;
    this.$state = $state;
    this.$timeout = $timeout;
    this.$scope = $scope;

    this.$scope.$on('reload.member-product-list', () => {
      this.loadProductList();
    });
  }

  $onInit() {
    this.session = this.SessionService.getSession();
    this.form = new RequestProductPasswordForm();
    this.error = new ProductPasswordFormErrorModel();
    this.loadProductList();
  }

  submit() {
    this.FormService.isSubmitting.next(true);
    this.TransactionApiService.createProductPassword(this.form.toPayload()).then((resp) => {
      this.FormService.isSubmitting.next(false);
      this.error.hasError = false;
      this.error.hasProductError = false;
      this.$timeout(() => {
        this.AppService.broadcast('reload.transaction-overview');
        this.onCloseModal();
      }, 2000);
    }).catch((errors) => {
      this.FormService.isSubmitting.next(false);
      this.error.hasError = true;
      this.error.setFormErrors(errors);
    });
  };

  viewPassword(element) {
    this.form.memberProductId = element;
    this.TransactionApiService.viewProductPassword(this.form.toViewPayload()).then(() => {
      this.loadProductList();
    }).catch(() => {
      return false;
    });
  }

  resetForm() {
    $('.copy-password').hide();
    $('.view-password').show();
    $('.copy-text').html('Copy');
    this.form.reset();
    this.error.clearFormErrors();
    this.loadProductList();
  }

  loadProductList() {
    this.CustomerApiService.getMemberProducts().then((resp) => {
      this.form.customerProducts = resp;
    });
  }

  isExpired(dateTime) {
    let dateNow = new Date(Date.now());
    let expirationDate = new Date(dateTime);
    let oneDay = 24 * 60 * 60 * 1000;

    if (dateNow - expirationDate > oneDay) {
      return true;
    } else {
      return false;
    }
  }

  expiresOn(dateTime) {
    let expirationDate = new Date(dateTime);

    return expirationDate.setDate(expirationDate.getDate() + 1);
  }

  hasMemberProductError(errors) {
    this.error.hasProductError = false;
    angular.forEach(errors, (value, key) => {
      if (value.children.memberProductId.errors) {
        this.error.hasProductError = true;
      } else {
        if (!this.error.hasProductError) {
          this.error.hasProductError = false;
        }
      }
    });

    return this.error.hasProductError;
  }

  copyToClipBoard(element) {
    let copyText = document.getElementById('cp-'+element);
    copyText.select();
    document.execCommand('copy');

    let tooltip = document.getElementById('tp-'+element);
    tooltip.innerHTML = 'Copied';
  };

  onCloseModal() {
    hideModal('requestProductPassword');
    this.resetForm();
    this.error.hasError = true;
    this.error.hasProductError = false;
  }
}

export default ProductPassword;


// WEBPACK FOOTER //
// ./client/app/shared/system-components/product-password-widget/product-password-widget.controller.js